import { AxiosPromise, AxiosRequestConfig } from 'axios';
import Http from '../../shared/http';
import {
  API_PATH_TLS_PROFILE,
  TlsProfile,
} from './tlsProfile.types';
import { ServerResponse, WithAuditDetails } from '../types';

const http = Http.getHttp();

export function getTlsProfileList(
  deliveryFunctionId: string,
): AxiosPromise<ServerResponse<TlsProfile>> {
  return http.get(`${API_PATH_TLS_PROFILE}/${deliveryFunctionId}`);
}

export function getTlsProfile(
  deliveryFunctionId: string,
  id: string,
): AxiosPromise<ServerResponse<TlsProfile>> {
  return http.get(`${API_PATH_TLS_PROFILE}/${deliveryFunctionId}/${id}`);
}

export function createTlsProfile(
  deliveryFunctionId: string,
  body: WithAuditDetails<TlsProfile>,
): AxiosPromise<ServerResponse<TlsProfile>> {
  return http.post(`${API_PATH_TLS_PROFILE}/${deliveryFunctionId}`, body);
}

export function updateTlsProfile(
  deliveryFunctionId: string,
  id: string,
  body: WithAuditDetails<TlsProfile>,
): AxiosPromise<ServerResponse<TlsProfile>> {
  return http.put(`${API_PATH_TLS_PROFILE}/${deliveryFunctionId}/${id}`, body);
}

export function deleteTlsProfile(
  deliveryFunctionId: string,
  id: string,
  body: WithAuditDetails<void>,
): AxiosPromise<ServerResponse<TlsProfile>> {
  return http.delete(`${API_PATH_TLS_PROFILE}/${deliveryFunctionId}/${id}`, { data: body.auditDetails });
}
